import React, { forwardRef } from 'react';
import { ChevronDown } from 'lucide-react';
import { clsx } from 'clsx';

interface DropdownOption {
  value: string;
  label: string;
}

interface DropdownProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  options: DropdownOption[];
  placeholder?: string;
  error?: string;
  className?: string;
}

export const Dropdown = forwardRef<HTMLSelectElement, DropdownProps>(({
  options,
  placeholder,
  error,
  className,
  ...props
}, ref) => {
  return (
    <div className="w-full">
      <div className="relative">
        <select
          ref={ref}
          className={clsx(
            'w-full min-h-[42px] px-3 py-2 border border-border bg-background rounded-md text-sm',
            'focus:outline-none focus:border-border',
            'appearance-none pr-10 text-foreground transition-colors',
            error && 'border-destructive focus:border-destructive',
            className
          )}
          {...props}
        >
          {placeholder && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground transition-transform pointer-events-none" />
      </div>
      {error && (
        <p className="mt-1 text-sm text-destructive">{error}</p>
      )}
    </div>
  );
});

Dropdown.displayName = 'Dropdown';
